import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 46 47"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-dasharray": "4 4",
      "stroke-width": "1.5",
      d: "M15.95 36.483H3.586a2 2 0 0 1-2-2V2.793a2 2 0 0 1 2-2h23.759a2 2 0 0 1 2 2v7.517"
    }, null, -1),
    _createElementVNode("path", { d: "M41.759 45.25h-23.76v1.5h23.76zM16.749 44V12.31h-1.5V44zM18 11.06h23.76v-1.5H18zm25.01 9.56V44h1.5V20.62zm0-8.31v8.31h1.5v-8.31zm-1.25-1.25c.69 0 1.25.56 1.25 1.25h1.5a2.75 2.75 0 0 0-2.75-2.75zM18 45.25c-.69 0-1.25-.56-1.25-1.25h-1.5A2.75 2.75 0 0 0 18 46.75zm23.76 1.5A2.75 2.75 0 0 0 44.51 44h-1.5c0 .69-.56 1.25-1.25 1.25zM16.75 12.31c0-.69.56-1.25 1.25-1.25v-1.5a2.75 2.75 0 0 0-2.75 2.75z" }, null, -1),
    _createElementVNode("circle", {
      cx: "29.92",
      cy: "24.96",
      r: "4.96"
    }, null, -1),
    _createElementVNode("path", { d: "M20 40c1.175-4.377 5.171-7.6 9.92-7.6s8.744 3.223 9.92 7.6" }, null, -1)
  ]))]))
}
export default { render: render }